import axios from 'axios'
import config from './config'
export default {
  getPatientRanking(){
   
  },
  getPatientInfo (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/patientinfo', {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getPatientDetails (pateintId = '') {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/patientinfo/' + pateintId, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getInstructions (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/instruction' , {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getPrecondition (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/precondition' , {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getSymptom (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
  
    console.log(token)
    return axios.get(config.serverURI + '/symptom' , {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getTask (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/task' , {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
    },
    getTaskLog (request = {}) {
      const ldata = localStorage.getItem('users')
      if ( ldata == null ) return []
      const data = JSON.parse( ldata )
      const token = data.token
      console.log('VVVVTOEKVVVV--->' + token)
      console.log(token)
      return axios.get(config.serverURI + '/tasklog' , {
          dataType: 'json',
          params:request,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error))
      },
      getFiles (request = {}) {
        const ldata = localStorage.getItem('users')
        if ( ldata == null ) return []
        const data = JSON.parse( ldata )
        const token = data.token
        console.log('VVVVTOEKVVVV--->' + token)
        console.log(token)
        return axios.get(config.serverURI + '/files' , {
            dataType: 'json',
            params:request,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
            }
          })
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
        },
        getReport (request = {}) {
          const ldata = localStorage.getItem('users')
          if ( ldata == null ) return []
          const data = JSON.parse( ldata )
          const token = data.token
          return axios.get(config.serverURI + '/patientreport', {
              dataType: 'json',
              params:request,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
        },
        getLocationReport (request = {}) {
          const ldata = localStorage.getItem('users')
          if ( ldata == null ) return []
          const data = JSON.parse( ldata )
          const token = data.token
          return axios.get(config.serverURI + '/patientloc', {
              dataType: 'json',
              params:request,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
        },
        getCaseReport (request = {}) {
          const ldata = localStorage.getItem('users')
          if ( ldata == null ) return []
          const data = JSON.parse( ldata )
          const token = data.token
          return axios.get(config.serverURI + '/patientcases', {
              dataType: 'json',
              params:request,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
        },
        getStatusReport (request = {}) {
          const ldata = localStorage.getItem('users')
          if ( ldata == null ) return []
          const data = JSON.parse( ldata )
          const token = data.token
          return axios.get(config.serverURI + '/patientstatus', {
              dataType: 'json',
              params:request,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
        }
}

/*
 axios.get(url, {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'no-cors',
          credentials: 'include'
        })
*/


// WEBPACK FOOTER //
// ./src/vuex/api/services/patients.js